// extracted by mini-css-extract-plugin
module.exports = {"modal":"PdfPreviewModal_modal__3TP6F","title":"PdfPreviewModal_title__1GG63"};